export enum PackagesType {
    SHOW_PACKAGES_LOADING = "SHOW_PACKAGES_LOADING",
    HIDE_PACKAGES_LOADING = "HIDE_PACKAGES_LOADING",
    REQUEST_CREATE_ORDER = "REQUEST_CREATE_ORDER",
    REQUEST_ORDER_INFO = "REQUEST_ORDER_INFO",
    SET_ORDER_INFO = "SET_ORDER_INFO",
    ADD_DISCOUNT_CODE = "ADD_DISCOUNT_CODE",
    REMOVE_DISCOUNT_CODE = "REMOVE_DISCOUNT_CODE",
    PAY_ORDER = "PAY_ORDER",
    CLEAR_PACKAGE_STATE = "CLEAR_PACKAGE_STATE",
    SEND_VAS_SMS = "SEND_VAS_SMS",
    VAS_SMS_SENT = "VAS_SMS_SENT",
    VERIFY_VAS_SMS = "VEIRFY_VAS_SMS",

    SEND_GIFT_CODE = "SEND_GIFT_CODE",
    GIFT_CODE_SENT = "GIFT_CODE_SENT",

    REQUEST_PACKAGES = "REQUEST_PACKAGES",
    SET_PACKAGES = "SET_PACKAGES",

    REQUEST_PACKAGE_DETAIL = "REQUEST_PACKAGE_DETAIL",
    SET_PACKAGE_DETAIL = "SET_PACKAGE_DETAIL",
    CLEAR_PACKAGE__DETAIL_STATE = "CLEAR_PACKAGE__DETAIL_STATE"
}